<template>
    <div id="app" @contextmenu.prevent>
        <!-- 注意，因为现在 utils 获取  container 是通过位置获取写死的，因此，这里的元素位置不要随意改动 -->
        <el-container>
            <!-- 要特别注意的是，el-header 的高度必须通过 style 属性设置，因为 el-header 在它的 element 上设置了 style height 60px，因此要覆盖的话，也必须在 element style 上设置 -->
            <el-header class="header box-shadow" style="height:50px"><header_/></el-header>
            <!-- el-main 的 overflow:auto 导致 position: sticky 不工作，干脆不适用 el-main 了，改用 div 也没有什么影响。-->
            <div class="main" style="">
                <!-- 第一层 div 默认 width 是 100 %，这样第二层 max-width=975px 的 div 才能居中，目前没有看到更好的方式 -->
                <div align="center" id="content-body">
                    <div class="max-width">
                        <!-- exclude Entity to fix bug HCF-214，VideoPlayer 在某些情况下不会被关闭（由 keep alive 导致的）-->
                        <!-- <keep-alive exclude="Entity"> --> <!-- 必须添加 keep alive，否则回退后不能正常返回，报错！-->
                        <keep-alive>
                            <router-view/>
                        </keep-alive>
                    </div>
                </div>
            </div>
<!--            <el-footer>-->
<!--                <div align="center">-->
<!--                    <div class="max-width" style="height: 50px;">-->
<!--                        <footer/>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </el-footer>-->
        </el-container>
        <wallpaper-previewer-image ref="wallpaperPreviewerImage"></wallpaper-previewer-image>
        <!-- 布局规则是：每个 icon 的宽度是 40，然后每个的间距是 12 -->
        <trash-bin v-if="isNativeApp" :left="20"></trash-bin>
        <deals :left="isNativeApp ? 72: 20"></deals>
        <view-his :left="isNativeApp ? 124: 72"></view-his>
        <follows :left="isNativeApp ? 176: 124"></follows>
        <contact-us v-if="isNativeApp" :left="228"></contact-us>
    </div>
</template>

<script>
    import header_ from './components/Header'
    import WallpaperPreviewerImage from "./components/commons/WallpaperPreviewerImage";
    import TrashBin from "./components/commons/stickpops/TrashBin";
    import Deals from './components/commons/stickpops/Deals';
    import ViewHis from "./components/commons/stickpops/ViewHis";
    import ContactUs from "./components/commons/stickpops/ContactUs";
    import {Constants, isHybridAgent, IapHelper, PaymentHelper, isNativeIosAgent} from "./utils";
    import Follows from "./components/commons/stickpops/Follows";
    var parseBool = require('parseboolean');

    export default {
        name: 'app',
        components: {
            Follows,
            header_,
            WallpaperPreviewerImage,
            TrashBin,
            Deals,
            ViewHis,
            ContactUs
        },
        mounted(){
            console.log('____________============ App.vue mounted. ============____________')
            // 初始化 confs 的操作硬挪动到 Header.vue 中
            // this.disableDoubleTapEnlarge();
            // if (this.isNativeApp){
                // (async()=>{
                    // console.log('try to init payment channel and resolve iap loss if iOS client');
                    // 因为 payment key 现在是从后台拿取了，是异步操作，因此，现在必须在 getConfs 完成后执行下面的操作，因此将这两个初始化步骤挪动到 Header.vue 中了。
                    // await this.initPaymentChannel();
                    // await this.resolveIapLoss();
                // })();
            // }
        },
        computed: {
            isNativeApp(){
                return isHybridAgent();
            },
            isNativeIosAgent(){
                return isNativeIosAgent();
            },
        },
        watch: {
            // 如果路由有变化，会再次执行该方法
            // '$route': 'routeChange'
        },
        methods: {

            /**
             * 尝试了很多方式
             * 1. 禁止屏幕缩放的大小 <meta name ="viewport" content ="width=device-width,initial-scale=1.0,maximum-scale=1.0,minimum-scale=1.0,user-scalable=no">
             * 2. touch-action: manipulation  改变 touch action 即是 tap 的行为
             * 3. 写了下面这个方法去捕获双击屏幕，然后将事件禁止
             * 结果，还是可以在 Safari 和 Chrome 中双击图片和文字进行放大。。....
             * @deprecated 实际上只要通过 touch-action 样式即可解决了。
             */
            disableDoubleTapEnlarge(){
                var time_stamp = 0; // Or Date.now()
                window.addEventListener("touchstart", function(e) {
                    if (e.timeStamp - time_stamp < 300) { // A tap that occurs less than 300 ms from the last tap will trigger a double tap. This delay may be different between browsers.
                        console.log('try to prevent double tap...')
                        e.preventDefault();
                        return false;
                    }
                    time_stamp = e.timeStamp;
                });
            }
        }
    }
</script>

<style>

    html { scroll-behavior: smooth;}

    body{
        font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        padding: 0;
        margin: 0;
    }

    #app {
        font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
        /*-webkit-font-smoothing: antialiased;*/
        /*-moz-osx-font-smoothing: grayscale;*/
        text-align: center;
        color: #2c3e50;
    }

    /* 解决 element-ui 很多组件在 Safari 浏览器中出现很粗的蓝色的边框*/
    * {
        outline: none;
    }

    /* H5，禁止双击放大屏幕，双指拖放(pinch)放大屏幕 */
    * {
        -ms-touch-action: pan-x pan-y  !important;
        touch-action: pan-x pan-y  !important;
    }

    /* 注意，以下的禁用只能作用到手机端，否则 PC 端 Carsousel 图片的放大功能将失效 */
    @media (max-width: 540px){
        img {
            pointer-events: none; /* 禁止 H5 长按图片弹出保存菜单 */
        }
        /* 全局禁止长按复制图片 */
        * {
            -webkit-touch-callout:none;  /*系统默认菜单被禁用*/
            -webkit-user-select:none; /*webkit浏览器*/
            -khtml-user-select:none; /*早期浏览器*/
            -moz-user-select:none; /*火狐*/
            -ms-user-select:none;  /*IE10*/
            user-select:none;
            /* For some Androids */
            -webkit-tap-highlight-color: rgba(0,0,0,0);
            -webkit-tap-highlight-color: transparent;
        }
        /* 必须恢复 input 和 textarea 的长按事件，否则不能输入内容了 */
        input, textarea {
            -webkit-user-select: auto;
            user-select:auto;
        }
    }

    /* 非常核心的一个参数，设置展示内容的最大宽度 */
    .max-width {
        max-width: 935px;
    }

    /* 响应式布局，注意，这个是作用在一个 div 中的，也就是我所说的一行，如果要作用到多个 div 元素上，样式就会乱掉 */
    .reactive-row {
        display: inline-flex;
        flex-direction: row;
        width: 100%; /* 控制响应式的核心参数 */
    }

    /* @media 中的 .el-image-self 会覆盖前面的 .el-image-self */
    @media (min-width: 736px) and (max-width: 974px) {
        /* 可以控制在特定尺寸下图片的大小，不再使用 px 和 vw 来控制大小，而是根据屏幕的尺寸自适应 */
        /* 为什么设置为 95.895%，是为了保证在 974 分辨率下，图片的尺寸和 instagram 完全一样，instagram 在 >= 975 后，图片尺寸便固定为 293 了 */
        .reactive-row{
            width: 95.895%;
        }
    }

    @media (min-width: 975px) {
        /* 当把 row 的宽度设置为 935 后，图片的尺寸自动适应到 293，公式：(935-2*28)/3=293 */
        .reactive-row{
            width: 935px;
        }
    }

    .header {
        background-color: #FFFFFF;
        height:50px;
        width:100%;
        position: fixed; /* 固定 header */
        top: -1; /* HCF 376 修复 head 上的一根若隐若现的横线 */
        z-index: 19;  /* 因为现在设计的 z-index 比较多，这里的 19 不要动，否则 PC / pad 端展示 bug，注意手机端设置的最大值 */
        /* opacity: .7;  没有达到我想要的效果，注释掉；设置 header 的透明度，注意必须在这里设置，而不能在 Header.vue 中的 pc-header 中设置 */
    }

    .el-header {
        margin: 0 0 !important;
        padding: 0 0 !important;
    }

    .main {
        background-color: rgb(250, 250, 250);
    }

    /* @deprecated, the el-main is not used any more */
    /*.el-main {*/
    /*    margin: 0 0 !important;  !* 该样式部署到 nginx 后失效，因此加上 important *!*/
    /*    padding: 0 0 !important; !* 该样式部署到 nginx 后失效，因此加上 important *!*/
    /*}*/

    :-webkit-direct-focus {
        outline-color: none;
        outline-style: auto;
        /*outline-width: 5px;*/
    }

    .el-footer{
        margin: 0 0 !important;
        padding: 0 0 !important;
    }

    .el-link{
        font-weight: 400
    }

    /** 统一设置 modal dialog 遮罩层的样式 **/
    .v-modal {
        opacity: .85 !important;
    }

    /** rotation，这里定义的 rotate 主要供 loading iconfont 使用 **/
    .rotate {
        animation: rotation 1.5s infinite linear;
    }

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(359deg);
        }
    }

    /* avatar */
    .avatar {
        border-radius:50%;
        overflow:hidden;
        border:0.5px dashed gray;
        cursor:pointer
    }

    .el-scrollbar__bar {
        opacity: 1 !important;
    }

    /* MessageBox/Confirm dialog 手机端适配 */
    @media (max-width: 540px) {
        .el-message-box {
            width: 100% !important;
            margin-top: 190px !important;
        }
        /* 调整 el-dialog 的 padding */
        .el-dialog--center .el-dialog__body{
            padding-left: 10px;
            padding-right: 10px;
        }
    }

    /** 全局覆盖 el-link 的样式 **/
    @media (min-width: 735px) {
        .el-link.el-link--default:hover {
            color: #CB0101 !important;
        }
    }

    /* mobile screen */
    @media (max-width: 735px) {
        .el-link.el-link--default:hover {
            color: unset !important;
        }
    }

    /* 全局覆盖 element 朴素按钮的 hover 样式，采用红底 */
    .el-button--default:hover {
        color: #F56C6C !important;
        border-color: #f7dae7 !important;
        background-color: #FDF7F6 !important;
    }

    /* 全局覆盖 text 按钮的样式 */
    .el-button--text {
        color: #F56C6C !important;
    }

    /* 全局覆盖 dialog 关闭按钮 hover 颜色为红色 */
    .el-dialog__headerbtn:hover .el-dialog__close {
        color: #CB0101 !important;
    }



    /* 全局覆盖 mobile Channle menu 的 hover 背景色为白色，默认是浅蓝色 */
    .el-menu-item{
        background-color: #FFFFFF !important;
    }

    /* 全局作用到 mobile screen 禁用所有的 el-tooltip 弹出窗口 */
    @media (max-width: 735px) {
        /* 禁用 element-ui tooltip 的弹出窗口；目前主要是作用于手机端用户评论界面，弹出窗口影响 UE */
        /* 现在有些组件需要用到 el-tooltip 的 manual 模式作为教程提示所用，因此不能全局禁用了。
        .el-tooltip__popper {
            display: none;
        }
        */
    }

</style>



// WEBPACK FOOTER //
// src/App.vue